import React from 'react';
import ToolTip from 'react-bootstrap/Tooltip';
import { Button } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { SearchVisibilityContextProvider, useSearch } from './SearchV2Context';

export const SearchV2 = () => {

    const { toggleShow } = useSearch();

    const styles = () => {
        return {
            padding: 0,
            border: 'none',
            fontSize: '1.1rem'
        };
    };

    return (
        <SearchVisibilityContextProvider>
            <OverlayTrigger placement="left" overlay={<ToolTip id="button-tooltip">[/]</ToolTip>}>
                <Button variant="text" style={styles()} onClick={toggleShow}>
                    <i className="fas fa-search" />
                </Button>
            </OverlayTrigger>
        </SearchVisibilityContextProvider>
    );
};
